<template>
  <div class="page-mentor">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/innovation`">创新创业</el-breadcrumb-item>
        <el-breadcrumb-item :to="`${$subsitePrefix}/innovation/investor-list`">投资人</el-breadcrumb-item>
        <el-breadcrumb-item>{{ data.Name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content mentor-content" v-loading="loading">
        <div class="card">
          <div class="avatar">
            <img @error="imgError" class="avatar_img" :src="data.Photo" :alt="data.Name" />
          </div>
          <div class="right">
            <h3>{{ data.Name }}</h3>
            <p>
              <span>手机号：{{ data.Telephone }}</span>
              <!-- <span>导师类型：{{ data.Type }}</span> -->
              <span>资金数量：{{ data.FundAmount }}</span>
              <span>投资偏好：{{ data.Preference }}</span>
            </p>
          </div>
        </div>
        <div class="content-wrap">
          <column-header2 :data="{ name: '个人简介' }"></column-header2>
          <div class="content">{{ data.Introduction }}</div>
          <column-header2 :data="{ name: '投资记录' }"></column-header2>
          <div class="content">{{ data.Investment }}</div>
          <!-- <column-header2 :data="{ name: '获奖情况' }"></column-header2>
          <div class="content">{{ data.Reward }}</div>
          <column-header2 :data="{ name: '双创项目' }"></column-header2>
          <div class="content">{{ data.Project }}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetail } from "api/app";
import ColumnHeader from "_c/ColumnHeader2";
export default {
  data() {
    return {
      loading: false,
      data: {}
    };
  },
  created() {
    this.init();
  },
  components: {
    [ColumnHeader.name]: ColumnHeader
  },
  methods: {
    loadData() {
      this.loading = true;
      getDetail({ name: "Investor", id: this.$route.params.id })
        .then(res => {
          this.data = res || {};
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    init() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-mentor {
  background: #f6f6f9;
  padding-bottom: 40px;
  .mentor-content {
    padding: 0 0 40px 0;
    .card {
      background: url(~assets/img/feature/watermarker.png) no-repeat #5463a4 95%
        top;
      background-size: 170px auto;
      border-radius: 8px 8px 0 0;
      color: #fff;
      height: 102px;
      padding: 16px 40px;
      display: flex;
      align-items: center;
      .avatar {
        width: 104px;
        height: 104px;
        margin-right: 24px;
        .avatar_img {
          border-radius: 52px;
        }
      }
      .right {
        display: flex;
        flex-direction: column;
        justify-content: center;
        h3 {
          font-size: 20px;
          font-weight: 500;
          padding-bottom: 8px;
        }
        p {
          width: 760px;
          display: flex;
          flex-wrap: wrap;
          line-height: 22px;
          span {
            width: 33%;
          }
        }
      }
    }
    .content {
      font-size: 14px;
      line-height: 28px;
      color: #666;
      padding-bottom: 20px;
    }
    ::v-deep .comp-column-header {
      padding-top: 24px;
    }
    .content-wrap {
      margin: 0 168px;
    }
  }
}
</style>
